import { render, staticRenderFns } from "./GenresList.vue?vue&type=template&id=1e583ac8&scoped=true&"
import script from "./GenresList.vue?vue&type=script&lang=js&"
export * from "./GenresList.vue?vue&type=script&lang=js&"
import style0 from "./GenresList.vue?vue&type=style&index=0&id=1e583ac8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e583ac8",
  null
  
)

export default component.exports